export interface IBusinessHoliday {
  id?: string
  startDate: string // YYYY-MM-DD
  endDate: string // YYYY-MM-DD（単日の場合は startDate と同じ）
  reason?: string
  createdAt?: string
  updatedAt?: string
}

const DAY_MS = 86400000

const toUtcDate = (dateStr: string): number => {
  const [y, m, d] = dateStr.split("-").map(Number)
  return Date.UTC(y, m - 1, d)
}

/** 指定日がいずれかの休業日範囲に含まれるか */
export const isDateInHolidays = (dateStr: string, holidays: IBusinessHoliday[]): boolean => {
  const t = toUtcDate(dateStr)
  return holidays.some(h => t >= toUtcDate(h.startDate) && t <= toUtcDate(h.endDate))
}

/** 指定期間（開始日〜終了日）の全日が、登録済み休業日の組み合わせで埋まっているか */
export const isRangeFullyHoliday = (
  startDate: string,
  endDate: string,
  holidays: IBusinessHoliday[]
): boolean => {
  if (holidays.length === 0) return false
  let t = toUtcDate(startDate)
  const end = toUtcDate(endDate)
  while (t <= end) {
    if (!holidays.some(h => t >= toUtcDate(h.startDate) && t <= toUtcDate(h.endDate))) {
      return false
    }
    t += DAY_MS
  }
  return true
}
